import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import PrismSpinner from '../prism/spinner/prismSpinner';

export default class SpinnerModal extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        message: PropTypes.string
    };

    static defaultProps = {
        className: '',
        message: 'Processing...'
    };

    render() {
        const className = classNames('spinner-modal', this.props.className);

        return (
            <Modal.Dialog className={className}>
                <div className="spinner-modal__spinner">
                     <PrismSpinner color="white" size="xl"/>
                </div>

                <span className='spinner-modal__processing'>{this.props.message}</span>
            </Modal.Dialog>
        );
    }
}
